import moment from 'moment'
import Api from './Api'

type Context = {
  perPage: any
  currentPage: number
  sortBy: any
  sortDesc: boolean
  filter: any
  query: any
}

export default class SalesActivity {
  public filters: any = {
    dates: {
      start: moment().startOf('year').format('YYYY-MM-DD hh:mm:ss'),
      shortcut: null,
      end: moment().format('YYYY-MM-DD hh:mm:ss'),
    },
  }

  public queryAutomatedFilters(module: any) {
    let automated_filters: any = {}
    let query: any = []

    if (module.query && module.query.length) {
      query = [...module.query]
    }

    if (module.local_filters) {
      Object.entries(module.local_filters).forEach(([key, value]) => {
        if (key === 'dynamic_filter') {
          automated_filters.start = module.local_filters.dynamic_filter.start
          automated_filters.end = module.local_filters.dynamic_filter.end
          automated_filters.shortcut = module.local_filters.dynamic_filter.shortcut
        } else {
          automated_filters[key] = value
        }
      })
    }

    if (module.local_query && module.local_query.length) {
      query = module.local_query
    }

    if (module.region) {
      query.push(`region:${module.region}`)
    }

    if (module.sales_rep) {
      query.push(`sr:${module.sales_rep}`)
    }

    query = [...new Set(query)]

    return {
      query,
      automated_filters,
    }
  }

  public pagination_settings(context: Context) {
    return {
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...context.query],
      mode: 'exclusive',
    }
  }

  public async targetOps({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    if (!ignore_logic) {
      return api
        .get('sales-activity/target-ops', { query, ...automated_filters })
        .then((response: any) => response.data)
        .catch(err => ({ data: [] }))
    }
    return api
      .get('sales-activity/target-ops', module)
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async meetings({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get('sales-activity/meetings', ignore_logic ? module : { query, ...automated_filters })
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async pitchedRev({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get(
        'sales-activity/pitched-revenue',
        ignore_logic ? module : { query, ...automated_filters },
      )
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async numberOfPitched({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get(
        'sales-activity/number-of-pitched',
        ignore_logic ? module : { query, ...automated_filters },
      )
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async soldPer({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get('sales-activity/sold-per', ignore_logic ? module : { query, ...automated_filters })
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async touchpoints({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get('sales-activity/touch-points', ignore_logic ? module : { query, ...automated_filters })
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async pipelineMovement({ module, ignore_logic }: { module: any; ignore_logic: boolean }) {
    const { query, automated_filters } = this.queryAutomatedFilters(module)

    let api = new Api()

    return api
      .get(
        'sales-activity/pipeline-movement',
        ignore_logic ? module : { query, ...automated_filters },
      )
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async pipelineMovementWeekly({
    module,
    ignore_logic,
  }: {
    module: any
    ignore_logic: boolean
  }) {
    let api = new Api()

    if (!ignore_logic) {
      const { query, automated_filters } = this.queryAutomatedFilters(module)
      return api
        .get('sales-activity/pipeline-movement-this-week', { query, ...automated_filters })
        .then((response: any) => response.data)
        .catch(err => ({ data: [] }))
    }
    return api
      .post('sales-activity/pipeline-movement-this-week', module)
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }
}
